import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import VueSweetalert2 from 'vue-sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';
import endpoint from "./plugins/endpoint";
import store from "./store/index";
import axiosPlugin from "./plugins/axios";
import alert from "./plugins/alert";
const app:any= createApp(App).use(router)
app.config.productionTip = false
// window.$ = window.jQuery = require('jquery');
// app.use(VueSweetalert2);
app.use(axiosPlugin)
app.use(endpoint)
app.use(alert)
app.use(store)
app.mount('#app')
